import { Message } from '@aid/chat/types/classes';

export class CustomerMessage extends Message {}
